import { render, staticRenderFns } from "./addInstitute.vue?vue&type=template&id=4f3a5e30"
import script from "./addInstitute.vue?vue&type=script&lang=js"
export * from "./addInstitute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports